import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MomentUtils from '@date-io/moment';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import { useForm, Controller } from 'react-hook-form';
import { useDataTable } from '../../../components/datatable/DataTable';
import useIdVendor from '../../../helpers/IdVendor';
import useFetch from 'use-http';

export default function ProductDialog(props) {
  const { register, handleSubmit, reset, control, errors } = useForm();
  const dataTable = useDataTable();
  const { getId } = useIdVendor('shipment');


  const handleClose = (event) => {
    props.onClose();
  };


  const onSubmit = async (data) => {
    const id = await getId();

    await dataTable.request.post({ id, ...data });

    if (dataTable.response.ok) {
      reset();
      props.onClose(data);
    }
  };

  return (
    <div>
      <Dialog open={props.open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Add Purchase Order</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Add a new purchase order
          </DialogContentText>
          <form onSubmit={handleSubmit(onSubmit)}>

            <TextField
              inputRef={register}
              autoFocus
              margin="dense"
              name="reference"
              label="Reference"
              type="string"
              fullWidth
            />

            <MuiPickersUtilsProvider utils={MomentUtils}>
              <Controller
                as={
                  <KeyboardDatePicker
                    variant="inline"
                    format="dd/MM/yyyy"
                    label="Incoming date"
                  />
                }
                control={control}
                name="incoming_date"
                placeholder="Incoming date"
              />
            </MuiPickersUtilsProvider>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button type="submit" onClick={handleSubmit(onSubmit)} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}